import { useLazyQuery } from "@apollo/client";
import { GetEstimatedDeliveryDateDocument } from "../../gql/generated/graphql";

interface Props {
  orderId: string;
}

export const useGetEstimatedDeliveryDate = ({ orderId }: Props) => {
  const [getEstimatedDeliveryDate] = useLazyQuery(
    GetEstimatedDeliveryDateDocument,
    {
      variables: { orderId },
    }
  );

  return {
    getEstimatedDeliveryDate: async () => {
      const { data } = await getEstimatedDeliveryDate();
      if (!data?.getEstimatedDeliveryDate) {
        throw new Error("Failed to get estimated delivery date");
      }

      return data?.getEstimatedDeliveryDate;
    },
  };
};
